<template>
  <div>
    <BaseFormLabel
      v-if="label"
      :name="name"
      :label="label"
      :note="note"
      :required="required"
    />

    <div class="flex flex-wrap">
      <div v-for="option in options" :key="option.id" class="pb-2 pr-2 w-1/3">
        <Field
          v-slot="{ field, handleChange }"
          type="radio"
          :name="name"
          :value="option.id"
          :validateOnMount="true"
        >
          <BaseRadio
            :field="field"
            :name="name"
            :value="option.id"
            :disabled="disabled"
            :on-change="handleChange"
          >
            {{
              optionFormatType === 'number'
                ? amountFormatter(option.name)
                : option.name
            }}{{ unit }}
          </BaseRadio>
        </Field>
      </div>
    </div>

    <BaseErrorMessage v-if="errorMessage" :name="name" />
  </div>
</template>

<script>
import { Field } from 'vee-validate';

import { amountFormatter } from '@/utils/filters.js';
import BaseFormLabel from '@/components/form/BaseFormLabel.vue';
import BaseRadio from '@/components/form/BaseRadio.vue';
import BaseErrorMessage from '@/components/form/BaseErrorMessage.vue';

export default {
  components: {
    Field,
    BaseFormLabel,
    BaseRadio,
    BaseErrorMessage,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: '',
    },
    note: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    optionFormatType: String,
    unit: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    field: {
      type: Object,
    },
    onChange: {
      type: Function,
    },
    errorMessage: {
      type: String,
      default: '',
    },
  },
  setup() {
    return {
      amountFormatter,
    };
  },
};
</script>

<style lang="scss" scoped></style>
